import { IconSparkles } from '@u21/tabler-icons';
import { AIAgentList } from 'app/modules/aiAdmin/components/AIAgentList';
import { ExperimentationAdmin } from 'app/modules/aiAdmin/components/ExperimentationAdmin';
import { PromptsAdmin } from 'app/modules/aiAdmin/components/PromptsAdmin';
import { U21Page } from 'app/shared/u21-ui/components';
import { U21PermissionedTabRouter } from 'app/shared/u21-ui/components/dashboard';
import { ROUTES_MAP } from 'app/shared/utils/routes';
import { AiAdminTracking } from 'app/modules/aiAdmin/components/aiAdminTracking/AiAdminTracking';
import { AiStats } from 'app/modules/aiAdmin/components/AiStats';

export const AiAdminDashboard = () => {
  return (
    <U21Page title="AI Admin Dashboard" titleIcon={<IconSparkles />}>
      <U21PermissionedTabRouter
        tabs={[
          {
            component: <AIAgentList />,
            label: 'AI Agents',
            path: ROUTES_MAP.aiAdminAgents.path,
            permissions: ROUTES_MAP.aiAdminAgents.permissions,
          },
          {
            component: <AiAdminTracking />,
            label: 'AI Tracking',
            path: ROUTES_MAP.aiAdminTracking.path,
            permissions: ROUTES_MAP.aiAdminTracking.permissions,
          },
          {
            component: <AiStats />,
            label: 'AI Stats',
            path: ROUTES_MAP.aiAdminStats.path,
            permissions: ROUTES_MAP.aiAdminTracking.permissions,
          },
          {
            component: <PromptsAdmin />,
            label: 'Prompts',
            path: ROUTES_MAP.aiAdminPrompts.path,
            permissions: ROUTES_MAP.aiAdminPrompts.permissions,
          },
          {
            component: <ExperimentationAdmin />,
            label: 'Experimentation',
            path: ROUTES_MAP.aiAdminExperimentation.path,
            permissions: ROUTES_MAP.aiAdminExperimentation.permissions,
          },
        ]}
      />
    </U21Page>
  );
};
